export default "__VITE_ASSET__gbSYwdUX__"